module.exports = __webpack_public_path__ + "assets/img/3.fcd40747.jpg";